import styles from './deviceModelUpsertModal.module.css';
import textFieldStyles from 'ui/TextField/textField.module.css';

import attentionIcon from 'assets/svg/attention-01.svg';

import { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useForm, FormProvider } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import classNames from 'classnames';
import { address_server_short, PUBLIC_ASSETS } from '../../../../config';
import { getAllUserFields } from 'services/list.services';
import { userFieldCategory } from 'consts/userField.consts';
import useAlert from 'hooks/useAlert';
import { UserFields } from 'components/UserFields';
import { MultiItemList } from 'components/Widgets/MultiInputList';
import Modal from '../../../../ui/Modal';
import FormTextField from 'ui/formItems/FormTextField';
import { devicesModelsStore } from 'store/mobx/devicesModels.store';

const DeviceModelUpsertModal = observer(({ setModalOpened, mode }) => {
  const { showAlert } = useAlert();
  const { setStateDeviceModel, upsertDeviceModel, stateDeviceModel, icons, setIcons } =
  devicesModelsStore;
  const [deviceDetails, setDeviceDetails] = useState(stateDeviceModel?.specifications ?? []);
  const userFieldsRef = useRef(null);

  const form = useForm({
    defaultValues: {
      name: stateDeviceModel?.name ?? '',
      description: stateDeviceModel?.description ?? '',
      image: stateDeviceModel?.image ?? '',
      user_fields: stateDeviceModel?.user_fields ?? undefined,
      specifications: stateDeviceModel?.specifications ?? [{ name: '', value: '' }],
    },
  });

  const {
    handleSubmit,
    formState: { errors },
    setValue,
    control,
  } = form;

  useEffect(() => {
    setIcons();
  }, []);

  useEffect(() => {
    setValue('specifications', deviceDetails);
  }, [deviceDetails, setValue]);

  const closeModalClick = () => {
    setModalOpened(false);
  };

  const submitClick = async (data) => {
    if (
      !data.name?.trim() ||
      !data.image?.trim() ||
      data.specifications?.some((item) => !(item?.name?.trim() && item?.value?.trim()))
    )
      return;

    const deviceModelData = {
      ...stateDeviceModel,
      name: data.name,
      description: data.description?.length ? data.description : undefined,
      image: data.image,
      user_fields: data.user_fields?.length ? data.user_fields : undefined,
      specifications: data.specifications?.length ? data.specifications : undefined,
    };

    if (stateDeviceModel?.id != null) {
      deviceModelData.id = stateDeviceModel.id;
    }

    setStateDeviceModel(deviceModelData);

    const result = await upsertDeviceModel();

    if (!result.success) {
      errorCommonAlert(result.error_code, result.error);
    } else {
      successUpsertTypesDeviceAlert();
      closeModalClick();
    }
  };

  const changeItemByIndex = (key, value, index) => {
    let res = JSON.parse(JSON.stringify(deviceDetails));
    let item = res[index];
    if (item) {
      item[key] = value;
    }
    setDeviceDetails(res);
  };

  const addItem = () => {
    let res = JSON.parse(JSON.stringify(deviceDetails));
    res.push({ name: '', value: '' });
    setDeviceDetails(res);
  };

  const deleteItem = (index) => {
    let res = JSON.parse(JSON.stringify(deviceDetails));
    res.splice(index, 1);
    setDeviceDetails(res);
  };

  const errorCommonAlert = (code, message) => {
    showAlert(` Код № ${code}${message ? ` - ${message}` : ''}!`, 'error');
  };

  const successUpsertTypesDeviceAlert = () =>
    showAlert(
      stateDeviceModel?.id != null
        ? `Модель оборудования успешно изменена!`
        : 'Модель оборудования добавлена успешно!',
      'success',
    );

  const Item = (value, index) => {
    return (
      <div key={index} className={styles.itemRow}>
        <div className={styles.textField}>
          <Controller
            name={`specifications.${index}.name`}
            control={form.control}
            rules={{ required: ' ' }}
            render={({ field, fieldState }) => (
              <div className={styles.inputContainer}>
                <div>Название</div>
                <input
                  {...field}
                  className={styles.input}
                  value={value.name}
                  onChange={(e) => changeItemByIndex('name', e.target.value, index)}
                />
                {fieldState.error && !value.name?.trim() && (
                  <div className={styles.dataErrorBlock}>
                    <img src={attentionIcon} alt="attention" />
                    <div className={styles.dataError}>
                      {fieldState.error.message && 'Поле обязательно для заполнения'}
                    </div>
                  </div>
                )}
              </div>
            )}
          />
        </div>
        <div className={styles.textField}>
          <Controller
            name={`specifications.${index}.value`}
            control={form.control}
            rules={{ required: ' ' }}
            render={({ field, fieldState }) => (
              <div className={styles.inputContainer}>
                <div>Значение</div>
                <input
                  {...field}
                  className={styles.input}
                  value={value.value}
                  onChange={(e) => changeItemByIndex('value', e.target.value, index)}
                />
                <div className={styles.buttonClear} onClick={() => deleteItem(index)}>
                  <div className={'close_icon'}></div>
                </div>
                {fieldState.error && !value.value?.trim() && (
                  <div className={styles.dataErrorBlock}>
                    <img src={attentionIcon} alt="attention" />
                    <div className={styles.dataError}>
                      {fieldState.error.message && 'Поле обязательно для заполнения'}
                    </div>
                  </div>
                )}
              </div>
            )}
          />
        </div>
      </div>
    );
  };

  return (
    <Modal
      title={`${stateDeviceModel?.id ? 'Редактировать' : 'Добавить'} модель оборудования`}
      onSubmit={handleSubmit(submitClick)}
      onClose={closeModalClick}
    >
      <FormProvider {...form}>
        <div className={styles.modalBody}>
          <FormTextField name="name" label={'Наименование'} required />
          <FormTextField label="Описание" name="description" />
          <Controller
            name="image"
            control={control}
            rules={{ required: 'Поле обязательно для заполнения' }}
            render={({ field }) => (
              <div className={classNames(textFieldStyles.formField, styles.iconsField)}>
                <div className={styles.formFieldContainer}>
                  <div className={textFieldStyles.label}>{'Иконка'}</div>
                  <div className={styles.iconsContainer}>
                    {icons.map((url, index) => (
                      <div
                        key={index}
                        className={classNames(
                          { [styles.bg_blue]: url === field.value },
                          styles.itemIcon,
                        )}
                        onClick={() => {
                          field.onChange(url);
                        }}
                      >
                        <div className={styles.containerImg}>
                          <img
                            src={address_server_short + PUBLIC_ASSETS + url}
                            className={styles.itemImg}
                            alt={'img'}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                {errors.image && (
                  <div className={styles.dataErrorBlock}>
                    <img src={attentionIcon} alt={'attention'} />
                    <div className={textFieldStyles.dataError}>{errors.image.message}</div>
                  </div>
                )}
              </div>
            )}
          />
          <p className={styles.categoryTitle}>Пользовательские параметры</p>
          <Controller
            name="user_fields"
            control={control}
            render={() => (
              <UserFields
                ref={userFieldsRef}
                onChange={(fields) => setValue('user_fields', fields)}
                mode={mode}
                category={userFieldCategory.device}
                loadApi={(options) => getAllUserFields(options, 'device')}
                defaultFields={stateDeviceModel?.user_fields}
              />
            )}
          />
          <p className={styles.categoryTitle}>Характеристики</p>
          <div>
            <Controller
              name="specifications"
              control={control}
              render={() => (
                <MultiItemList
                  items={deviceDetails}
                  onChange={addItem}
                  Item={Item}
                  confirmButton={'Добавить поле'}
                />
              )}
            />
          </div>
        </div>
      </FormProvider>
    </Modal>
  );
});

export default DeviceModelUpsertModal;
